var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkdinicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5771 24.9546C28.457 24.9546 26.7383 26.6733 26.7383 28.7934C26.7383 30.9136 28.457 32.6323 30.5771 32.6323C32.6972 32.6323 34.4159 30.9136 34.4159 28.7934C34.4159 26.6733 32.6972 24.9546 30.5771 24.9546ZM28.8322 28.7934C28.8322 27.8297 29.6134 27.0485 30.5771 27.0485C31.5408 27.0485 32.322 27.8297 32.322 28.7934C32.322 29.7571 31.5408 30.5383 30.5771 30.5383C29.6134 30.5383 28.8322 29.7571 28.8322 28.7934Z",
    fill: "#1DF66A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7383 34.3772C26.7383 33.799 27.207 33.3302 27.7852 33.3302H33.369C33.9472 33.3302 34.4159 33.799 34.4159 34.3772V52.5244C34.4159 53.1026 33.9472 53.5713 33.369 53.5713H27.7852C27.207 53.5713 26.7383 53.1026 26.7383 52.5244V34.3772ZM28.8322 35.4241V51.4774H32.322V35.4241H28.8322Z",
    fill: "#1DF66A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5099 34.3772C36.5099 33.799 36.9786 33.3302 37.5568 33.3302H43.1406C43.7188 33.3302 44.1875 33.799 44.1875 34.3772V34.9831L44.7951 34.7226C45.8398 34.2749 46.9569 33.9942 48.0867 33.8915C51.9604 33.5393 55.355 36.5833 55.355 40.4917V52.5244C55.355 53.1026 54.8863 53.5713 54.3081 53.5713H48.7243C48.1461 53.5713 47.6774 53.1026 47.6774 52.5244V42.7528C47.6774 42.29 47.4935 41.8462 47.1663 41.519C46.8391 41.1917 46.3952 41.0079 45.9324 41.0079C45.4697 41.0079 45.0258 41.1917 44.6986 41.519C44.3714 41.8462 44.1875 42.29 44.1875 42.7528V52.5244C44.1875 53.1026 43.7188 53.5713 43.1406 53.5713H37.5568C36.9786 53.5713 36.5099 53.1026 36.5099 52.5244V34.3772ZM38.6038 35.4241V51.4774H42.0936V42.7528C42.0936 41.7347 42.4981 40.7583 43.218 40.0384C43.9379 39.3184 44.9143 38.914 45.9324 38.914C46.9506 38.914 47.927 39.3184 48.6469 40.0384C49.3668 40.7583 49.7713 41.7347 49.7713 42.7528V51.4774H53.2611V40.4917C53.2611 37.8333 50.9425 35.7344 48.2763 35.9768C47.3633 36.0598 46.4607 36.2869 45.62 36.6473L43.553 37.5331C43.2295 37.6717 42.858 37.6386 42.5642 37.4448C42.2704 37.2511 42.0936 36.9227 42.0936 36.5708V35.4241H38.6038Z",
    fill: "#1DF66A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5864 40.0296L25.6294 15.7064L53.7153 15.7064L67.7583 40.0296L53.7153 64.3527L25.6294 64.3527L11.5864 40.0296Z",
    fill: "#1DF66A",
    fillOpacity: 0.12,
    stroke: "url(#paint0_linear_541_427)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_541_427",
    x1: 25.3407,
    y1: 15.2064,
    x2: 60.7009,
    y2: 77.5307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DF66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FCFCFC",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D968F",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinicon);
export default __webpack_public_path__ + "static/media/linkdinicon.1c003a1c5a7527a6319a4be5e746f524.svg";
export { ForwardRef as ReactComponent };